import { Injectable} from '@angular/core';

import { User } from '../models/user';
import {HttpService} from "./http.service";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import {CookieService} from 'ngx-cookie-service';
import { environment } from '../../environments/environment';

import 'rxjs/add/operator/toPromise';
import * as _ from "lodash";

@Injectable()
export class UserService {

    private loggedInUid: string;
    private cookiePath: string = '/';

    get userId(): string {
        return this.cookieService.get("btphuid")
    }

    set userId(id: string) {
        this.cookieService.set("btphuid", id, 14, this.cookiePath);
    }

    get accountRole(): string {
        return this.cookieService.get("btphurole")
    }

    set accountRole(id: string) {
        this.cookieService.set("btphurole", id, 14, this.cookiePath)
    }

    get isSuper(): boolean {
        return this.cookieService.get('btphsup') === 'true';
    }

    set isSuper(isSuper: boolean) {
        this.cookieService.set('btphsup', '' + !!isSuper, 14, this.cookiePath);
    }

    get accountId(): string {
        return this.cookieService.get("btphaid")
    }

    set accountId(id: string) {
        this.cookieService.set("btphaid", id, 14, this.cookiePath)
    }

    get accountName(): string {
        return this.cookieService.get('btphan');
    }

    set accountName(name: string) {
        this.cookieService.set('btphan', name, 14, this.cookiePath);
    }

    get accountBucketName(): string {
        let name = this.accountName;
        return _.kebabCase(`prizehublive ${environment.name} ${name}`);
    }

    set userEmail(email: string) {
        this.cookieService.set('btphue', email, 14, this.cookiePath);
    }

    get userEmail(): string {
        return this.cookieService.get('btphue');
    }

    constructor(
        private httpService: HttpService,
        private toastr: ToastsManager,
        private cookieService: CookieService
    ) {}

    isLoggedIn(): boolean {
        return !!this.userId;
    }

    get(id: string): Promise<User> {
        let me = this;
        let params = {
            filter: JSON.stringify({"include": { "assignedMachines": "machine"}})
        };
        //let url: string = `/Accounts/${me.accountId}/users/${id}`;
        let url: string = `/ZMUsers/${id}`;
        return this.httpService.get(url, params)
            .then(function (result:any) {
                return new User().fromJson(result);
            })
            .catch(function (error:any) {
                me.httpService.handleError(error, "Unable to retrieve user details")
                throw error
            })
    }

    delete(user: User): Promise<any> {
      let me = this;
      return this.httpService.delete(`/ZMUsers/${user.id}`, user)
        .then(function(result: any){
          me.toastr.success("User removed successfully");
          return result;
        })
        .catch(function(error: any) {
          me.httpService.handleError(error, "Unable to remove user")
        })
    }

    update(user: User): Promise<any> {
        let me = this;
        return this.httpService.post(`/ZMUsers/${user.id}/editUser`, user)
            .then(function(result: any){
                me.toastr.success("User Updated Successfully");
                return result;
            })
            .catch(function(error: any) {
                me.httpService.handleError(error, "Unable to Update User")
            })
    }

    create(user: User): Promise<any> {
        let me = this;
        return this.httpService.post("/ZMUsers/wizardCreate", user)
        .then(function(result: any){
            me.toastr.success("User Created Successfully");
            return result;
        })
        .catch(function(error: any) {
            me.httpService.handleError(error, "Unable to Create User")
        })
    }

    me(): Promise<User> {
        let me = this;
        let params = {
            filter: JSON.stringify({"include": "account"})
        };
        return this.httpService.get(`/ZMUsers/${this.userId}`, params)
        .then(function(result: any){
            return new User().fromJson(result);
        })
        .catch(function(error: any){
           me.httpService.handleError(error, "Unable to retrieve logged in user")
        })
    }
    logout(): Promise<any> {
        let me = this;
        return this.httpService.post("/ZMUsers/logout", {})
        .then(function(result: any){
            me.clearSession();
            return {success: true};
        })
        .catch(function(error: any) {
            me.httpService.handleError(error, "Logout Failed")
        })
    }

    clearSession() {
        this.httpService.accessToken = '';
        this.userId = '';
        this.accountId = '';
        this.isSuper = false;
        this.accountName = '';
        this.accountRole = '';
        this.userEmail = '';
    }

    login(email: string, password: string): Promise<any> {
        let params: any = {email: email, password: password};
        let me = this;
        return this.httpService.post("/ZMUsers/login", params)
        .then(function(result: any){
            me.httpService.accessToken = result.id;
            me.userId = result.userId;
            me.isSuper = result.isSuper;
            //fetch this user and store their account Id
            return me.httpService.get(`/ZMUsers/${result.userId}`, {})
            .then(function(result: any){
                if (result) {
                    me.accountId = result.accountId;
                    me.accountRole = result.accountRole || "";
                    me.userEmail = email || '';
                    return result;
                }

            })
        })
        .catch(function(error: any): Promise<any> {
            if (error.status === 401 || error.status === 403) {
                me.toastr.error("Email or Password is not Valid");
            } else {
                me.toastr.error("Login Failed")
            }
            return null;
        })
    }

    passwordReset(password: string, accessToken: string): Promise<any> {
        let params: any = {newPassword: password};
        let me = this;
        //promise doesn't need to return any data here, just
        //let calling code know we are finished and if it worked
        return this.httpService.post("/ZMUsers/reset-password", params, accessToken)
        .then(function(result: any){
            return true;
        })
        .catch(function(error: any): Promise<any> {
            return null;
        })
    }

    passwordResetEmail(email: string): Promise<any> {
        let params: any = {email: email};
        let me = this;
        //this just sends an email out, promise just lets
        //the client know it's finished, no real data to pass
        return this.httpService.post("/ZMUsers/passwordresetemail", params)
        .then(function(result: any){
            me.toastr.info('Password reset email sent')
            return true;
        })
        .catch(function(error: any): Promise<any> {
            me.toastr.error('Unable to send password reset email');
            return null;
        })
    }

    resendVerification(user: User): Promise<any> {
        let me = this;
        return this.httpService.post(`/ZMUsers/${user.id}/verify`, {})
            .then(function(result: any) {
                me.toastr.success('Verification email sent');
                return true;
            })
            .catch(function(error:any) {
                me.toastr.error('Unable to send verifictaion email');
                return false;
            });
    }

    getAssignedMachines(userid): Promise<any> {
        let me = this;
        let params = { };
        let url: string = `/MachineAssignments/${userid}/listAvailableMachines`; // automatically includes hubs and slots
        return this.httpService.get(url, params)
            .then(function (result:any) {
                if (result) {
                    if (typeof result === 'string') {
                        return JSON.parse(result);
                    }
                    return result;

                }
                return [];
            })
            .catch(function (error:any) {
                me.httpService.handleError(error, "Unable to retrieve machine details")
            })
    }

    checkIfEmailExists(email): Promise<any> {
        let me = this;
        let params = { };
        let url: string = `/ZMUsers/exists/${email}`;
        return this.httpService.get(url, params)
            .then(function (result:any) {
                if (result !== null) {
                    return result;
                } else {
                    return [];
                }
            })
            .catch(function (error:any) {
                me.httpService.handleError(error, "Unable to retrieve machine details")
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts